import { TimelineEntityMeta } from "store/apis/filingsTimeline";

export type OverdueAcrossYears = {
  beforeCount: number;
  afterCount: number;
  jumpYearBefore: number | null;
  jumpYearAfter: number | null;
};

const sumOverdue = (stats: { year: number; overdue_count: number }[]): number =>
  stats.reduce((total, stat) => total + stat.overdue_count, 0);

export const getOverdueAcrossYears = (
  entities: TimelineEntityMeta[],
  viewedYear: number
): OverdueAcrossYears => {
  const stats = entities.flatMap((entity) => entity.year_stats);

  const before = stats.filter((stat) => stat.year < viewedYear);
  const after = stats.filter((stat) => stat.year > viewedYear);

  const overdueYearsBefore = before
    .filter((stat) => stat.overdue_count > 0)
    .map((stat) => stat.year);
  const overdueYearsAfter = after
    .filter((stat) => stat.overdue_count > 0)
    .map((stat) => stat.year);

  return {
    beforeCount: sumOverdue(before),
    afterCount: sumOverdue(after),
    jumpYearBefore:
      overdueYearsBefore.length > 0 ? Math.max(...overdueYearsBefore) : null,
    jumpYearAfter:
      overdueYearsAfter.length > 0 ? Math.min(...overdueYearsAfter) : null,
  };
};
